module.exports = __webpack_public_path__ + "assets/images/BBD10.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/BBD10.png
// module id = 1308
// module chunks = 1